let stored: string | null = null

/**
 * Holds the in-memory challenge grant minted at sign-in. Deliberately has no client TTL: the backend owns
 * grant validity (`MfaChallengeGrant.redeem!` rejects an expired grant with `invalid_or_expired_challenge_grant`),
 * so mirroring its expiry here only risks drift and premature lockout. The grant lives until consumed or the
 * tab closes. Callers redeem it and route to `/login` on the backend's expiry rejection.
 */
export const mfaChallengeGrant = {
  set(grant: string): void {
    stored = grant
  },

  get(): string | null {
    return stored
  },

  clear(): void {
    stored = null
  },
}
